module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_5.3cb1a4b6.png";